// extracted by mini-css-extract-plugin
module.exports = {"editableCell":"inputModalSemiProduct_editableCell__1BHXD","itemScroll":"inputModalSemiProduct_itemScroll__1Sb34"};